import { render, staticRenderFns } from "./mynotice.vue?vue&type=template&id=01535310&scoped=true&"
import script from "./mynotice.vue?vue&type=script&lang=js&"
export * from "./mynotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01535310",
  null
  
)

export default component.exports